// Metered usage for a team (/v1/usage). Returns per-dimension totals plus a
// daily UTC time series over a [from, to) window (default: last 30 days).

import { getJSON, query } from "./http.js";

/**
 * The five metered dimensions, each summed over the window, except
 * storage_gb: it is the window's peak daily value.
 */
export interface UsageDimensions {
  build_count: number;
  compute_seconds: number;
  preview_instance_hours: number;
  storage_gb: number;
  live_instance_hours: number;
}

/** One day's bucket carries all five dimensions (0 when absent that day). */
export interface UsageDay extends UsageDimensions {
  date: string;
}

export interface UsageReport {
  teamId: string;
  from: string;
  to: string;
  totals: UsageDimensions;
  /** Daily buckets, only for days with events. */
  series: UsageDay[];
}

export interface UsageWindow {
  /** RFC3339 or YYYY-MM-DD. Defaults server-side to `to` − 30 days. */
  from?: string;
  /** RFC3339 or YYYY-MM-DD. Defaults server-side to now. */
  to?: string;
}

/** getUsage returns the team's usage report over the given window (member+). */
export function getUsage(teamId: string, window: UsageWindow = {}): Promise<UsageReport> {
  return getJSON<UsageReport>(`/v1/usage${query({ team: teamId, from: window.from, to: window.to })}`);
}
